<div class="market-history">
  <h2 class="heading">{{"market-depth" | translate}}
    <span matTooltipPosition="left" [matTooltip]='companyName' matTooltipClass="custom-tooltip" *ngIf="reuters != null">- <span style="background:#2d3034;padding: 5px; border-radius: 5px;"> {{reuters}}</span></span>
  </h2>
  <div id="recent-trades">
    <table class="table row m-0 p-0 custom-depth" *ngIf="isOrder">
      <thead>
        <tr class="d-flex justify-content-between">
          <th style="text-align: start;">{{"price"|translate}}</th>
          <th class="text-center">{{"qty"|translate}}</th>
          <th style="text-align: end;">{{"price"|translate}}</th>
        </tr>
      </thead>

      <tbody class="custom-tbody" *ngIf="companyDepth != null && companyDepth.bids.length>0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.bids">
          <td class="red">{{depth.ORDER_PRICE}}</td>
          <td>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}</td>
        </tr>
      </tbody>
      <tbody class="custom-tbody" *ngIf="companyDepth!=null && companyDepth.bids.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> No Bids </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody style="width: 100%; height: 88%;" class="d-flex justify-content-center" *ngIf="isDepthLoading">
        <div class="spinner-border text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>

      <tbody class="custom-tbody" *ngIf="companyDepth != null && companyDepth.asks.length>0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.asks">
          <td>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}</td>
          <td class="green">{{depth.ORDER_PRICE}}</td>
          <!-- <td>15.27648</td> -->
        </tr>
      </tbody>
      <tbody class="custom-tbody" *ngIf="companyDepth!=null && companyDepth.asks.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> No Asks </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody style="width: 100%; height: 88%;" class="d-flex justify-content-center" *ngIf="isDepthLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>

      <tfoot *ngIf="companyDepth" class="totals-footer">
        <tr class="d-flex justify-content-around">
          <div class="red">
            {{companyDepth.totalsBidsAndAsks.TOTAL_BIDS | number: "1.0":"en-US"}}
          </div>
          <div>{{'TOTAL'|translate}}</div>
          <div class=" green">
            {{companyDepth.totalsBidsAndAsks.TOTAL_ASKS | number: "1.0":"en-US"}}
          </div>
        </tr>
      </tfoot>
    </table>

    <table class="table row m-0 p-0 custom-depth" *ngIf="!isOrder">
      <thead>
        <tr class="d-flex justify-content-between">
          <th style="text-align: start;">#</th>
          <th style="text-align: start;">{{"qty"|translate}}</th>
          <th class="text-center">{{"price"|translate}}</th>
          <th style="text-align: end;">{{"qty"|translate}}</th>
          <th style="text-align: end;">#</th>
        </tr>
      </thead>
      <tbody class="custom-tbody" *ngIf="companyDepth != null && companyDepth.bidsPerPrice.length > 0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.bidsPerPrice" class="d-flex">
          <td style="width: 30% !important;">
            {{depth.split}}
          </td>
          <td style="text-align: center; width: 35% !important;">
            <div> {{depth.VOLUME_TRADED | number: "1.0":"en-US"}}
            </div>
          </td>
          <td class="red" style="width: 35% !important;">
            <div style="text-align: end;">{{depth.ORDER_PRICE}}</div>
          </td>
          <!-- <td>15.27648</td> -->
        </tr>
      </tbody>
      <tbody class="custom-tbody" *ngIf="companyDepth!=null && companyDepth.bidsPerPrice.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> No Bids </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody style="width: 100%; height: 88%;" class="d-flex justify-content-center" *ngIf="isDepthLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <!-- <tbody  class="ob-heading" style="height: 50px;" *ngIf="companyDepth != null">
          <tr>
            <td class="red">
              <span>Total Bids</span>
              {{companyDepth.totalsBidsAndAsks.TOTAL_BIDS}}
            </td>
            <td style="width: 20%;" class="green">
              <span>Total Asks</span>
              {{companyDepth.totalsBidsAndAsks.TOTAL_ASKS}}
            </td>
          </tr>
        </tbody> -->
      <tbody class="custom-tbody" *ngIf="companyDepth != null && companyDepth.asksPerPrice.length > 0 && !isDepthLoading">
        <tr *ngFor="let depth of companyDepth.asksPerPrice" class="d-flex">
          <td class="green" style="width: 35% !important;">
            <div>{{depth.ORDER_PRICE | number: "1.0":"en-US"}}</div>
          </td>
          <td style="text-align: center;width: 35% !important;">
            <div>{{depth.VOLUME_TRADED | number: "1.0":"en-US"}}</div>
          </td>
          <td style="text-align: end; width: 30% !important;">{{depth.split}}</td>
          <!-- <td>15.27648</td> -->
        </tr>
      </tbody>
      <tbody class="custom-tbody" *ngIf="companyDepth!=null && companyDepth.asksPerPrice.length == 0 && !isDepthLoading">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> No Asks </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody style="width: 100%; height: 88%;" class="d-flex justify-content-center" *ngIf="isDepthLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <tbody *ngIf="!companyDepth && !isDepthLoading" style="width: 100%; height: 100%;">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tfoot *ngIf="companyDepth" class="totals-footer">
        <tr class="d-flex justify-content-around">
          <div class="red">
            {{companyDepth.totalsBidsAndAsks.TOTAL_BIDS | number: "1.0":"en-US"}}
          </div>
          <div>{{'TOTAL'|translate}}</div>
          <div class=" green">
            {{companyDepth.totalsBidsAndAsks.TOTAL_ASKS | number: "1.0":"en-US"}}
          </div>
        </tr>
      </tfoot>

    </table>
  </div>
</div>
